import { PayLinksWorkspace } from "@/features/invoices/components/PayLinksWorkspace";

export function PayLinksPage() {
  return <PayLinksWorkspace />;
}
